<!----------------------------   Program description   ----------------------------
- Vue Name ID   :passwdChng_popup
- Vue Name  :passwdChng_popup
- Author      :노희원
- Create Date :
- Change History
======================================================================================
 수정일           / 이름 / 사유
======================================================================================
 YYYY.MM.DD  / XYZ / 신규
--------------------------------------------------------------------------------------->


<!-------------------------------------------------------------------------------------
- 1. template
--------------------------------------------------------------------------------------->
<template>
  <div class="layer-content">
    <h1 class="tit-type1">비밀번호 변경안내</h1>
    <ul class="txt-type1 depth1">
      <li>회원님께서는 <span class="pc01">6개월 이상 비밀번호</span>를 변경하지 않으셨습니다.</li>
      <li>동일한 비밀번호를 장기간 사용할 경우 <span class="pc01">개인정보 도용 및 유출의 위험</span>이 있으니,<br>소중한 개인정보보호를 위해 비밀번호를 변경해주세요.</li>
    </ul>
    <h1 class="tit-type1">안전한 비밀번호 설정방법</h1>
    <ul class="txt-type1 depth1">
      <li>비밀번호는 <span class="pc01">최소 8자~ 15자 이내로 영문, 특수문자, 숫자의 조합으로 등록</span>해주셔야 합니다.</li>
      <li>비밀번호는 도용이 가능한 연속된 숫자 4자리, 전화번호, 키보드에서 나란히 있는 문자, <br>잘 알려진 영단어로는 비밀번호 설정이 불가능합니다.</li>
    </ul>
    <div style="margin-top:20px;padding:15px 20px;border-top:1px solid #454545;border-bottom:1px solid #454545;">
      <table class="tb-none" style="margin-left: 30px;">
        <colgroup>
          <col style="width:30%;" />
          <col style="width:auto" />
        </colgroup>
        <tbody>
          <tr>
            <th>현재 비밀번호</th>
            <td><input type="password" style="width:80%;" placeholder="현재 비밀번호 입력"
                       ref="curPassword" v-model="curPassword"/></td>
          </tr>
          <tr>
            <th>새 비밀번호</th>
            <td><input type="password" style="width:80%;" placeholder="새 비밀번호 입력"
                       ref="newPassword" @keyup.space="spaceKeyUp('new')"
                       v-model="newPassword"/></td>
          </tr>
          <tr>
            <th>새 비밀번호 확인</th>
            <td><input type="password" style="width:80%;" placeholder="새 비밀번호 확인"
                       ref="newPasswordChk" v-model="newPasswordChk"
                       @keyup.space="spaceKeyUp('chk')"/></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="btn-wrap center mgt20">
      <button class="big _bt-gray" @click="nextChngPassCheck()"><span>90일 뒤에 변경하기</span></button>
      <button class="big _bt-blue" @click="saveChngPassCheck()"><span>저장</span></button>
    </div>
  </div>
</template>

<!-------------------------------------------------------------------------------------
- 2. Script
--------------------------------------------------------------------------------------->
<script>
/*======================================================================================*
     * 2.1. Import 
     *======================================================================================*/

export default {
  /*======================================================================================*
     * 2.2. 뷰 컴포넌트 명칭
     *======================================================================================*/
  name: 'passwdChngPopup',
  props: ['param'],

  /*======================================================================================*
     * 2.3. 지역 변수
     *======================================================================================*/
  data: function () {
    return {
        curPassword: '',
        newPassword: '',
        newPasswordChk: '',
        mberInfo: this.param.mberInfo,
    }
  },

  /*======================================================================================*
     * 2.3. 함수 (일반 함수, 사용자 정의 함수, 이벤트 함수)
     *======================================================================================*/
  methods: {
    init: function () {
    },
    nextChngPassCheck: function (){
        if(!confirm('동일한 비밀번호를 장기간 사용할 경우\n개인정보 도용 및 유출의 위험이 있습니다.\n'
            + '다음에 변경하시겠습니까?')) return false;

        this.axios.post('/i5gam/member/login/nextChngPasswd.act',{
          mberInfo: this.mberInfo
        }).then(function(response) {
          if(response.data.procCode == '001'){
            this.$toasted.show(this.$onbiLib.msg.suc.save, {duration:1000, type:'success'});
            this.closePopup();
          }
        }.bind(this)).catch(function(e) {
          console.log(e);
          this.$toasted.show(this.$onbiLib.msg.err.system);
        }.bind(this));
    },
    saveChngPassCheck: function (){
      if(this.curPassword == ''){
        this.$toasted.show("현재 비밀번호를 입력해주세요.");
        this.$refs.curPassword.focus();
        return false;
      }

      if(!this.validCheck()) {
        this.$refs.newPassword.focus();
        return false;
      }

      if(this.newPassword != this.newPasswordChk){
        this.$toasted.show("새 비밀번호가 일치하지않습니다.");
        this.$refs.newPasswordChk.focus();
        return false;
      }

      this.checkPassword().then(function(procCode){
        if(procCode == '001'){
          this.modifyPassword();
        }else if(procCode == '997'){
          this.$toasted.show('현재 비밀번호와 동일하게 변경 불가합니다.');
          this.$refs.newPassword.focus();
          return false;
        }else if(procCode == '998'){
          this.$toasted.show('이전 비밀번호와 동일하게 변경 불가합니다.');
          this.$refs.newPassword.focus();
          return false;
        }else if(procCode == '999'){
          this.$toasted.show('현재 비밀번호가 일치하지 않습니다.');
          this.$refs.curPassword.focus();
          return false;
        }
      }.bind(this));
    },
    modifyPassword : function(){
      this.axios.post('/i5gam/member/changePwProc.act', {
        mberInfo : {
          mberNo : this.mberInfo.mberNo,
          password : this.newPassword
        }
      }).then(function(response) {
        if(response.data.procCode == '001'){
            this.$toasted.show('비밀번호가 ' + this.$onbiLib.msg.suc.chng,{duration:1000, type:'success'});
            this.closePopup();
        }
      }.bind(this)).catch(function(e) {
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    validCheck: function (){
      let chk = 0;
      if(this.newPassword.search(/[0-9]/g) != -1 ) chk ++;
      if(this.newPassword.search(/[a-z]/ig)  != -1 ) chk ++;
      if(this.newPassword.search(/[!@#$%^&*()?_~]/g)  != -1  ) chk ++;

      if((chk < 3) || (this.newPassword.length < 8 || this.newPassword.length > 15)){
        this.$toasted.show("비밀번호는 영문, 숫자, 특수문자를 포함하여 8~15자로 생성해주세요.");
        return false;
      }
      //같은 문자 4번 제한
      if(!this.passwdRepeatKeyChk()) return false;

      //ID포함여부 체크
      if(!this.passwdIdChk()) return false;

      //연락처 포함여부 체크
      if(!this.passwdCttpcChk()) return false;

      //연속된 문자/숫자 정규식 생성
      if(!this.passwdCntnKeyChk()) return false;

      //잘알려진단어 체크
      if(!this.passwdKnownWordChk()) return false;

      return true;
    },
    checkPassword : function(){
      return new Promise(function(resolve, reject){
        this.axios.post('/i5gam/member/checkPwProc.act',{
          mberInfo : {
            mberNo : this.mberInfo.mberNo,
            password : this.curPassword,
            newPassword: this.newPassword
          }
        }).then(function(response) {
          const code = response.data.procCode;
          resolve(code);
        }.bind(this)).catch(function(e) {
          reject(e);
        });
      }.bind(this))
    },
    closePopup : function(){
      this.$store.commit('closePopup');
    },

    passwdCttpcChk: function (){
      let cttpc = this.mberInfo.cttpc.replaceAll('-','');
      if (this.newPassword.search(cttpc.substr(3,8)) > -1) {
        this.$toasted.show("연락처가 포함된 비밀번호는 사용하실 수 없습니다.");
        return false;
      }else return true;
    },
    passwdIdChk: function (){
      if (this.mberInfo.id.length > 5) {
        if (this.newPassword.search(this.mberInfo.id) > -1) {
          this.$toasted.show("ID가 포함된 비밀번호는 사용하실 수 없습니다.");
          return false;
        }else return true;
      }
    },
    passwdRepeatKeyChk: function (){
      if (/(\w)\1\1\1/.test(this.newPassword)) {
        this.$toasted.show('비밀번호에 같은 문자를 4번 연속 사용하실 수 없습니다.');
        return false;
      }else return true;
    },
    passwdCntnKeyChk: function (){
      const max = 4;
      const cntnlimit = ["0123456789", "9876543210",
        "qwertyuiopasdfghjklzxcvbnm",
        "QWERTYUIOPASDFGHJKLZXCVBNM"]
      let Pattern;

      for (let i = 0; i < cntnlimit.length; i++) {
        let check1 = cntnlimit[i];
        let check2 = cntnlimit[i] + cntnlimit[i];
        for (let j = 0; j < check1.length; j++) {
          let x = check1.substr(j, 1);
          let y = check2.substr(j, max);
          Pattern += "[" + x + "]{" + max + ",}|" + y + "|";
        }
      }
      Pattern = new RegExp(Pattern.replace(/.$/, ""));
      if (Pattern.test(this.newPassword)) {
        this.$toasted.show("연속된 숫자와 문자를 4번 연속 사용하실수 없습니다.");
        return false;
      }else return true;
    },
    passwdKnownWordChk: function (){
      const wordLimit = ["love", "LOVE", "happy", "HAPPY", "password", "PASSWORD"
        , "iloveyou", "ILOVEYOU", "dragon", "DRAGON", "sunshine"
        , "SUNSHINE", "princess", "PRINCESS", "letmein", "LETMEIN"
        , "monkey", "MONKEY", "superman", "SUPERMAN", "hello", "HELLO"
        , "google", "GOOGLE", "apple", "APPLE", "samsung", "SAMSUNG"]
      let msg = '';
      for (let i = 0; i < wordLimit.length; i++) {
        if (this.newPassword.search(wordLimit[i]) > -1) {
          msg = wordLimit[i];
        }
      }
      if (msg != '') {
        this.$toasted.show("비밀번호에 [" + msg + "]를 사용하실수 없습니다.");
        return false;
      }else return true;
    },
    spaceKeyUp: function(info){
      this.$toasted.show('공백입력은 불가합니다.');
      if(info == 'new'){
        this.newPassword = this.newPassword.replace(/ /gi,'');
      }else if(info =='chk'){
        this.chkPassword = this.chkPassword.replace(/ /gi,'');
      }
    },

  },

  /*======================================================================================*
     * 2.4. Vue Life Cycle
     *======================================================================================*/
  mounted: function () {
    this.init();
  }

}
</script>

<!-------------------------------------------------------------------------------------
- 3. 뷰 스타일 block
--------------------------------------------------------------------------------------->
<style scoped>

</style>